// Título em faixas alternadas sobre uma divisão vertical preto/branco.
// As medidas seguem a arte de referência fornecida para o canvas 640×800.
import { escapeHtml, toFlowText } from '../shared/text'
import { LOGO_PRETO_DATA_URI } from '../shared/logo'
import type { TemplateDefinition } from '../types'

export const CSS = `
  .tpl-titulo-blocos{
    padding:0;
    overflow:hidden;
    background:#000;
    color:var(--ink);
  }
  .tpl-titulo-blocos .paper-panel{
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    width:63.5%;
    background:var(--paper);
  }
  .tpl-titulo-blocos .logo{
    position:absolute;
    top:55px;
    right:50px;
    height:24px;
    z-index:3;
  }
  .tpl-titulo-blocos .display-title{
    position:absolute;
    top:118px;
    left:84px;
    z-index:2;
    font-family:'Anton',sans-serif;
    font-size:min(var(--template-vw-12-7, 12.7vw),81px);
    line-height:1;
    letter-spacing:-.012em;
    text-transform:uppercase;
  }
  .tpl-titulo-blocos .title-band{
    display:block;
    width:max-content;
    height:1.5em;
    padding-right:20px;
    line-height:1;
    white-space:nowrap;
  }
  .tpl-titulo-blocos .title-band--dark{
    color:#fff;
    background:#000;
  }
  .tpl-titulo-blocos .title-band--light{
    color:#000;
    background:#fff;
    padding-right:32px;
  }
  .tpl-titulo-blocos .title-band-text{
    display:block;
    transform:scaleY(1.5);
    transform-origin:top left;
  }
  .tpl-titulo-blocos .body-copy{
    position:absolute;
    top:570px;
    left:276px;
    right:50px;
    z-index:2;
    font-family:'Source Serif 4',serif;
    font-weight:300;
    font-size:17px;
    line-height:1.45;
    text-align:left;
  }
`

function render(content: Record<string, unknown>): string {
  const line1 = escapeHtml(String(content.titleLine1 ?? ''))
  const line2 = escapeHtml(String(content.titleLine2 ?? ''))
  const line3 = escapeHtml(String(content.titleLine3 ?? ''))
  const body = toFlowText(String(content.body ?? ''))

  return `<section class="slide tpl-titulo-blocos">
    <div class="paper-panel" aria-hidden="true"></div>
    <div class="logo reveal r1"><img src="${LOGO_PRETO_DATA_URI}" alt="Lorena"></div>
    <h2 class="display-title">
      <span class="title-band title-band--dark reveal r2"><span class="title-band-text">${line1}</span></span>
      <span class="title-band title-band--light reveal r3"><span class="title-band-text">${line2}</span></span>
      <span class="title-band title-band--dark reveal r4"><span class="title-band-text">${line3}</span></span>
    </h2>
    <p class="body-copy reveal r5">${body}</p>
  </section>`
}

export const tituloBlocosTemplate: TemplateDefinition = {
  id: 'titulo-blocos',
  label: 'Título em blocos',
  tags: ['texto', 'título', 'preto e branco'],
  css: CSS,
  fieldsSchema: [
    { key: 'titleLine1', label: 'Título — linha 1 (preta)', type: 'text', placeholder: 'ALGORITHMIC' },
    { key: 'titleLine2', label: 'Título — linha 2 (branca)', type: 'text', placeholder: 'SYSTEM' },
    { key: 'titleLine3', label: 'Título — linha 3 (preta)', type: 'text', placeholder: 'GENERATION' },
    {
      key: 'body',
      label: 'Texto',
      type: 'textarea',
      placeholder: 'Texto de apoio para desenvolver o conceito apresentado no título...',
    },
  ],
  render,
  previewContent: {
    titleLine1: 'ALGORITHMIC',
    titleLine2: 'SYSTEM',
    titleLine3: 'GENERATION',
    body: 'Apostando na integração entre dados, automação e inteligência artificial para aumentar a capacidade de análise e acelerar a validação de estratégias.',
  },
}
